import React from 'react';
import { TermsOfServicePresenter } from './presenter';

export const TermsOfService: React.VFC = () => {
  return <TermsOfServicePresenter />;
};
